import PropTypes from 'prop-types';

import category from './category';

export default PropTypes.shape({
  occasion: PropTypes.arrayOf(category),
  recipient: PropTypes.arrayOf(category),
  interest: PropTypes.arrayOf(category),
});
